import { render } from "./EditCallModal.vue?vue&type=template&id=68dfa155&scoped=true"
import script from "./EditCallModal.vue?vue&type=script&lang=js"
export * from "./EditCallModal.vue?vue&type=script&lang=js"

import "./EditCallModal.vue?vue&type=style&index=0&id=68dfa155&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68dfa155"]])

export default __exports__